import type { GdCallStatus, GdDiscountCodeOrigin, GdOrderStatus } from '../admin-schema'

/** Grid enum columns want a `Record`, `SelectEnumField` wants a list — both derive from the same map. */
function toOptions<T extends string>(labels: Record<T, string>): { value: T; label: string }[] {
	return (Object.entries(labels) as [T, string][]).map(([value, label]) => ({ value, label }))
}

export const gdCallStatusLabels: Record<GdCallStatus, string> = {
	draft: 'Koncept',
	pendingApproval: 'Ke schválení',
	published: 'Publikováno',
}

export const gdOrderStatusLabels: Record<GdOrderStatus, string> = {
	new: 'Nová',
	awaitingPayment: 'Čeká na platbu',
	paid: 'Zaplaceno',
	cancelled: 'Zrušeno',
	expired: 'Vypršelo',
}

export const gdDiscountCodeOriginLabels: Record<GdDiscountCodeOrigin, string> = {
	manual: 'Ruční',
	reactivation: 'Reaktivace',
}

export const gdCallStatusOptions = toOptions(gdCallStatusLabels)
export const gdOrderStatusOptions = toOptions(gdOrderStatusLabels)
export const gdDiscountCodeOriginOptions = toOptions(gdDiscountCodeOriginLabels)

/** Target of the „otevřít na webu“ link next to a GD page path. */
export const gdWebBaseUrl = 'https://www.grantovydiar.cz'
